import { Ticket } from '@/icons';
import { Price } from '@/atoms';
import { Button, CartIcon } from '@/molecules';

import { isExternal, isOutOfStock, whiteColorScheme } from '@/lib/utils';
import AvisameButton from '../buttons/Avisame';

import type { FunctionComponent } from 'react';
import type { ProductFormProps } from './types';

interface TypeProductFormProps extends ProductFormProps {
  disabled?: boolean;
}

/**
 * ProductForm
 */
export const ProductForm: FunctionComponent<TypeProductFormProps> = ({
  moreInfo,
  price,
  isSellerClosed,
  productId,
  stock,
  stockAlert = true,
  regularPrice,
  type,
  quantitySelector,
  state,
  disabled,
  externalUrl,
}: TypeProductFormProps) => (
  <div className="hidden flex-col border-t border-dashed border-primary-900 py-4 lg:flex">
    <div className="hidden flex-row items-center justify-between lg:flex">
      <div className="flex flex-row-reverse items-center divide-x-[1px] divide-x-reverse">
        <p className="u-actions u-actions--link flex flex-col pl-2 text-typo-secondary">
          {moreInfo}
        </p>
        <Price
          isDescription
          className="pr-2"
          price={price}
          regularPrice={regularPrice}
        />
      </div>

      {isSellerClosed || (stock && isOutOfStock(stock)) ? (
        stockAlert ? (
          <AvisameButton product={productId} />
        ) : null
      ) : (
        <>
          {type && isExternal(type) ? (
            <Button
              as="a"
              href={externalUrl ?? '#'}
              target="_blank"
              rel="noopener noreferrer"
              size="large"
            >
              Reservar
              <Ticket width={16} height={16} />
            </Button>
          ) : (
            <div className="flex gap-8">
              {quantitySelector}

              <Button
                type="submit"
                size="large"
                disabled={disabled || state === 'LOADING'}
                testid="add-to-cart"
              >
                Añadir
                <CartIcon
                  width={24}
                  height={24}
                  state={state}
                  colorScheme={whiteColorScheme}
                />
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  </div>
);

ProductForm.displayName = 'ProductForm';
